const updateEquipmentServices = {
  toastr: 'Updated service',
  toastrError: 'Service Type already registered',
  toastrError1: 'Enter another name'
};

export default updateEquipmentServices;
